// MultiSelect.js
import React from 'react';
import Select from 'react-select';

const MultiSelect = ({ options, selectedValues, onChange, fieldName, isMulti = true }) => {
  // If single-select, selectedValues is expected to be a single string or undefined, else an array for multi-select
  const selectedOptions = isMulti
    ? options.filter(option => selectedValues?.includes(option.value))
    : options.find(option => option.value === selectedValues) || null;

  const handleSelectChange = (selectedOption) => {
    if (isMulti) {
      // For multi-select, we pass an array of values
      onChange(fieldName, selectedOption ? selectedOption.map(option => option.value) : []);
    } else {
      // For single-select, we pass a single value
      onChange(fieldName, selectedOption ? selectedOption.value : null);
    }
  };

  return (
    <div >
      <label>{fieldName.replace(/([A-Z])/g, ' $1').trim()} *</label>
      <Select 
        options={options} 
        value={selectedOptions} 
        onChange={handleSelectChange} 
        isMulti={isMulti} 
        className="react-select-container"
      />
    </div>
  );
};

export default MultiSelect;

